import { useContext, useState } from 'react'
import BrandItem from './BrandItem'
import { AppContext } from '../../../contextApi/ContextApi'

export default function BrandSection({header, data, isDashboard, setDisplay}) {
    const {primary_color, accent_color} = useContext(AppContext);
    const [currentIndex, setCurrentIndex] = useState(0);

    const visibleProducts = data.slice(currentIndex, currentIndex + 3);

    const next = () => {
        if (currentIndex + 3 < data.length) {
            setCurrentIndex(prev => prev + 3);
        }
    };

    const prev = () => {
        if (currentIndex > 0) {
            setCurrentIndex(prev => prev - 3);
        }
    };
    const deployList=()=>{
        return visibleProducts.map((product, inx)=>{
            return <BrandItem key={`brandItem_inx_${inx}`} item={product} isDashboard={isDashboard} setDisplay={setDisplay}/>
        })
    }
    return (
        <div className='brandSection'>
            <h2 style={{textShadow:`2px 2px 3px ${primary_color}`, fontSize:"32px"}}>{header}</h2>
            <div className='brandSection_list'>
                <button disabled={currentIndex === 0} className='brandSection_list_arrows' id='brandSection_list_arrow_left' style={{color:accent_color}} onClick={()=>{prev()}}>⟨</button>
                {deployList()}
                <button disabled={currentIndex + 3 >= data.length} className='brandSection_list_arrows' id='brandSection_list_arrow_right' style={{color:accent_color}} onClick={()=>{next()}}>⟩</button>
            </div>
        </div>
    )
}
